import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../../redux/reducers/Models";
import { validateCPF } from "@/utils/functions";
import ForgotPasswordView from "./view";
import { useNavigate } from "react-router-dom";
import { setCustomer } from "@/redux/ducks/customer";

export default function ForgotPassword() {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    dispatch(setCustomer({ 
      forgot: {
        ...customer?.forgot,
        [name]:  value
      }
    }));
  }

  const getIsDisabled = () => {
    if (!validateCPF(customer?.forgot?.document!)) return true;
    return false;
  }

  const goToPin = () => {
    if (getIsDisabled()) return;
    
    navigate('/forgot/pin');
  }
  
  return <ForgotPasswordView 
    goBack={goBack}
    customer={customer}
    onChange={onChange}
    goToPin={goToPin}
    isDisabled={getIsDisabled()}
  />;
}
